import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { EventDto } from '@odo/shared-ui';
import { fetchActiveEvents } from '../services/events';
import { EVENTS_ACTIVE_KEY } from './queryKeys';

const STALE_TIME_MS = 60 * 1000;

// Backs `EventBannerStrip` - an event banner must never break the sidebar, so
// callers render nothing on `isLoading`/`isError` rather than surfacing a
// fallback UI (see EventBannerStrip.tsx).
export function useActiveEvents(): UseQueryResult<EventDto[]> {
    return useQuery({
        queryKey: [EVENTS_ACTIVE_KEY],
        queryFn: fetchActiveEvents,
        staleTime: STALE_TIME_MS
    });
}
